exports.f = Object.getOwnPropertySymbols;



/** WEBPACK FOOTER **
 ** ./~/babel-polyfill/~/core-js/modules/_object-gops.js
 **/